export const hprScoreLabels = {
  worstTissueTypeScore: "Worst Tissue Type",
  surfaceAreaValueScore: "Surface Area Value",
  intactValueScore: "Intact Value",
  hprScore: "Total HPR"
};
